"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The InviteColeaguesModel model module.
 * @module model/InviteColeaguesModel
 * @version 1.1.3-alpha.1
 */
class InviteColeaguesModel {
  /**
   * Constructs a new <code>InviteColeaguesModel</code>.
   * @alias module:model/InviteColeaguesModel
   * @param emails {Array.<String>} 
   */
  constructor(emails) {
    InviteColeaguesModel.initialize(this, emails);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, emails) {
    obj['emails'] = emails;
  }

  /**
   * Constructs a <code>InviteColeaguesModel</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InviteColeaguesModel} obj Optional instance to populate.
   * @return {module:model/InviteColeaguesModel} The populated <code>InviteColeaguesModel</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InviteColeaguesModel();
      if (data.hasOwnProperty('emails')) {
        obj['emails'] = _ApiClient.default.convertToType(data['emails'], ['String']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>InviteColeaguesModel</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InviteColeaguesModel</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of InviteColeaguesModel.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is an array
    if (!Array.isArray(data['emails'])) {
      throw new Error("Expected the field `emails` to be an array in the JSON data but got " + data['emails']);
    }
    return true;
  }
}
InviteColeaguesModel.RequiredProperties = ["emails"];

/**
 * @member {Array.<String>} emails
 */
InviteColeaguesModel.prototype['emails'] = undefined;
var _default = InviteColeaguesModel;
exports.default = _default;